module.exports = "/static/assets/8eed8e9cf5b6e386e496eb14f86564a6.png";